export const portfolioLabel = "Eric's Portfolio";

export const projects = [
    {
        id: 3,
        title: "Mythos",
        description: "Mythos is a Python package for simulating and fitting coarse-grained molecular models to macroscopic experimental data. My contributions have crash-tested code on local and remote Linux environments, including scheduling services like SLURM, to improve documentation and workflow for future users.",
        year: "2026",
        month: "06",
        url: "https://github.com/mythos-bio/mythos",
        hostedBy: "GitHub",
    },
    {
        id: 2,
        title: "Gaia DR3 Cone Search",
        description: "Python command-line tool for querying the Gaia Data Release 3 (DR3) catalog around a user-defined sky position. Produces a clean, IRAF-compatible star catalog.",
        year: "2025",
        month: "12",
        url: "https://github.com/EKHess/Gaia-DR3-Cone-Search",
        hostedBy: "GitHub",
    },
    {
        id: 1,
        title: "Titanic Survival Prediction with PyTorch",
        description: "A binary classification approach using PyTorch, featuring a complete machine learning workflow: data preprocessing, model construction, training, evaluation, and visualization.",
        year: "2025",
        month: "11",
        url: "https://github.com/EKHess/Titanic-Survivors",
        hostedBy: "GitHub",
    },
    {
        id: 0,
        title: "RAO Skywatch",
        description: "A front-end React web app to view cameras and instruments at the Rothney Astrophysical Observatory.",
        year: "2025",
        month: "01",
        url: "https://github.com/EKHess/RAO-Skywatch",
        hostedBy: "GitHub",
    },
]